(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.cfInit === 'true') return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cf-slide]'));
    if (slides.length === 0) return;
    root.dataset.cfInit = 'true';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cf-dot]'));
    var toggle = root.querySelector('[data-cf-toggle]');
    var count = slides.length;
    var current = 0;
    var timer = null;
    var hovering = false;

    var autoplay = root.dataset.cfAutoplay === 'true';
    var interval = parseInt(root.dataset.cfInterval, 10);
    if (!interval || interval < 1500) interval = 4000;

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function render() {
      var prev = (current - 1 + count) % count;
      var next = (current + 1) % count;
      for (var i = 0; i < count; i++) {
        var s = slides[i];
        s.classList.remove('is-active', 'is-prev', 'is-next');
        if (i === current) s.classList.add('is-active');
        else if (i === prev) s.classList.add('is-prev');
        else if (i === next) s.classList.add('is-next');
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === current);
      }
    }

    function go(index) {
      current = (index % count + count) % count;
      render();
    }
    function nextSlide() { go(current + 1); }
    function prevSlide() { go(current - 1); }

    function start() {
      if (count < 2) return;
      stop();
      root.classList.add('is-playing');
      timer = setInterval(function () {
        if (!hovering) nextSlide();
      }, interval);
    }
    function stop() {
      root.classList.remove('is-playing');
      if (timer) { clearInterval(timer); timer = null; }
    }
    function togglePlay() {
      if (timer) stop();
      else start();
    }

    // Dots jump to a slide
    for (var d = 0; d < dots.length; d++) {
      (function (dot) {
        dot.addEventListener('click', function () {
          go(parseInt(dot.dataset.index, 10));
        });
      })(dots[d]);
    }

    // Click a side card to go prev/next
    for (var k = 0; k < slides.length; k++) {
      (function (slide) {
        slide.addEventListener('click', function () {
          if (slide.classList.contains('is-prev')) prevSlide();
          else if (slide.classList.contains('is-next')) nextSlide();
        });
      })(slides[k]);
    }

    if (toggle) toggle.addEventListener('click', togglePlay);

    // Pause auto-play while the pointer is over the carousel
    root.addEventListener('mouseenter', function () { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });

    // Keyboard arrows for accessibility
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prevSlide(); }
      else if (e.key === 'ArrowRight') { nextSlide(); }
    });

    // Expose a minimal API so the Theme Editor can focus a selected slide.
    root._cfGoToSlide = function (slideEl) {
      var idx = slides.indexOf(slideEl);
      if (idx >= 0) { stop(); go(idx); }
    };

    render();
    if (autoplay && !reduceMotion) start();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cf-root]');
    for (var i = 0; i < roots.length; i++) {
      initCarousel(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-initialise when the section is (re)rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Bring a slide to the center when its block is selected in the Theme Editor.
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest ? event.target.closest('[data-cf-slide]') : null;
    var root = slide && slide.closest ? slide.closest('[data-cf-root]') : null;
    if (root && typeof root._cfGoToSlide === 'function') {
      root._cfGoToSlide(slide);
    }
  });
})();
